var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24Print(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2.5C7.01625 2.5 6 3.51625 6 4.75V5.5H5.25C3.46403 5.5 2 6.96403 2 8.75V15.75C2 16.9838 3.01625 18 4.25 18H6V19.25C6 20.4838 7.01625 21.5 8.25 21.5H15.75C16.9838 21.5 18 20.4838 18 19.25V18H19.75C20.9838 18 22 16.9838 22 15.75V8.75C22 6.96403 20.536 5.5 18.75 5.5H18V4.75C18 3.51625 16.9838 2.5 15.75 2.5H8.25ZM8.25 4H15.75C16.1732 4 16.5 4.32675 16.5 4.75V5.5H7.5V4.75C7.5 4.32675 7.82675 4 8.25 4ZM5.25 7H18.75C19.725 7 20.5 7.77497 20.5 8.75V15.75C20.5 16.1732 20.1733 16.5 19.75 16.5H18V14.75C18 13.5162 16.9838 12.5 15.75 12.5H8.25C7.01625 12.5 6 13.5162 6 14.75V16.5H4.25C3.82675 16.5 3.5 16.1732 3.5 15.75V8.75C3.5 7.77497 4.27497 7 5.25 7ZM8.25 14H15.75C16.1732 14 16.5 14.3268 16.5 14.75V19.25C16.5 19.6733 16.1732 20 15.75 20H8.25C7.82675 20 7.5 19.6733 7.5 19.25V14.75C7.5 14.3268 7.82675 14 8.25 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24Print);
export default __webpack_public_path__ + "static/media/icn_24x24_print.7151dd209a986907204ae216bdce83f0.svg";
export { ForwardRef as ReactComponent };